export default __webpack_public_path__ + "../images/cart.svg";